import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import nth0 from "@/modules/nth0";

import { isIPhone } from "@/modules/iOSDetection";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";

import { assetImg } from "@/modules/moduleImporter";
import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";
import { betGroupProp } from "@/modules/commonMobile";

import Portrait from "./Portrait";

export const tiles = [["gunting,jempol", "batu,telunjuk", "kertas,kelingking"],
    ["batu,kelingking", "kertas,jempol", "gunting,telunjuk"],
    ["kertas,telunjuk", "gunting,kelingking", "batu,jempol"]];

export const rowTiles = [
    ["gunting-jempol", "batu-kelingking", "kertas-telunjuk"],
    ["batu-telunjuk", "kertas-jempol", "gunting-kelingking"],
    ["kertas-kelingking", "gunting-telunjuk", "batu-jempol"]];

//Suwit
export default class M19 extends React.Component<IGameTableType> {
    state = { activeHover: "" }

    render() {
        const { langdata } = this.props;

        const win = this.props.win || "";
        const wins = win.split(",");

        const commonChipProps = {
            mobile: this.props.mobile,
            chipBase: this.props.chipBase,
            bets: this.props.bets,
            betOutOfBounds: this.props.betOutOfBounds
        };

        const commonTooltipProps = {
            langStr: langdata.language_code
        };

        if (this.props.portrait)
            return <Portrait {...this.props} />

        return (
            <div className="sl-table m19-game">
                <div className="m19-square">
                    {["gunting", "batu", "kertas"].map((item, idx) =>
                        <div key={`m19_g_square_${idx}`} className={"sl-bet m19-grey " + (wins[0] === item ? "sl-yellow-alternating" : "")}
                            {...betGroupProp(this, item, "n")}
                            onClick={this.props.insertBet}>

                            {assetImg("m19", item)}
                            <div className="bet-type">1:1.95</div>

                            <Chips {...commonChipProps} betKey={item + "+n"} />
                            <Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
                        </div>
                    )}
                </div>

                {
                    tiles.map((col, colIdx) => (
                        <div key={"m19_c_" + colIdx} className="m19-rectangle">
                            <div className={"sl-bet sl-green-old" + (col.indexOf(win) >= 0 ? " sl-yellow-alternating" : "")}>

                                <div dangerouslySetInnerHTML={{ __html: this.props.langdata["txt_" + nth0(colIdx) + "_line"] }}></div>
                                <div className="bet-type">1:1.75</div>

                                <Chips {...commonChipProps} betKey={"kolom" + (colIdx + 1) + "+n3"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["kolom" + (colIdx + 1) + "+n3"]} />
                                <div className="sl-hover-hidden"
                                    {...betGroupProp(this, `kolom${colIdx + 1}`, "n3")}
                                    onClick={this.props.insertBet}
                                    onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined}
                                    onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined} />
                            </div>
                            {
                                col.map((cell, rowIdx) => {
                                    const cellsplit = cell.split(",");
                                    const betKey = cellsplit.join("-");

                                    return (<div key={`m19_g_rectangle_${rowIdx}`}
                                        className={"sl-bet sl-green-old" + (
                                                (this.state.activeHover.indexOf(betKey) >= 0 ||
                                                    this.state.activeHover === ("kolom" + (colIdx + 1)) ||
                                                    this.state.activeHover === ("baris" + (rowIdx + 1))
                                                ) ? " sl-bet-hover" : "")
                                            + (win === cell ? " sl-yellow-alternating" : "")}
                                        {...betGroupProp(this, betKey, "c")}
                                        onClick={this.props.insertBet}>

                                        {assetImg("m19", cellsplit[0], "m19_" + rowIdx + "_" + colIdx + "_" + cellsplit[0])}
                                        {assetImg("m19", cellsplit[1], "m19_" + rowIdx + "_" + colIdx + "_" + cellsplit[1])}

                                        <div className="bet-type">1:7.5</div>
                                        <Chips {...commonChipProps} betKey={betKey + "+c"} />
                                        <Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+c"]} />
                                    </div>)
                                }) //col.map
                            }
                        </div>
                    )) //tiles.map
                }

                <div className="m19-rectangle">
                    {
                        rowTiles.map((row, rowIdx) => (
                            <div key={`m19_g_rectangle2_${rowIdx}`} className={"sl-bet sl-green-old " +
                                (row.indexOf(win.replace(",", "-")) >= 0 ? "sl-yellow-alternating" : "")}>

                                <div dangerouslySetInnerHTML={{ __html: this.props.langdata["txt_" + nth0(rowIdx) + "_row"] }}></div>
                                <div className="bet-type">1:1.75</div>

                                <Chips {...commonChipProps} betKey={"baris" + (rowIdx + 1) + "+n3"} />

                                <Tooltip {...commonTooltipProps} bet={this.props.bets["baris" + (rowIdx + 1) + "+n3"]} />
                                <div className="sl-hover-hidden"
                                    {...betGroupProp(this, `baris${rowIdx + 1}`, "n3")}
                                    onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
                            </div>
                        )
                        )
                    }
                </div>
                <div className="m19-square-right">
                    {
                        ["jempol", "telunjuk", "kelingking"].map((item, idx) =>
                            <div key={`m19_g_square-right_${idx}`} className={"sl-bet sl-red-darken " + (wins[1] === item ? "sl-yellow-alternating" : "")}
                                {...betGroupProp(this, item, "n")}
                                onClick={this.props.insertBet}>

                                {assetImg("m19", item)}
                                <div className="bet-type">1:1.95</div>

                                <Chips {...commonChipProps} betKey={item + "+n"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
                            </div>
                        )
                    }
                </div>

                {/*Multibet starts here*/}
                {
                    [
                        [
                            "gunting-jempol,batu-kelingking",
                            "batu-kelingking,kertas-telunjuk"
                        ],
                        [
                            "batu-telunjuk,kertas-jempol",
                            "kertas-jempol,gunting-kelingking"
                        ],
                        [
                            "kertas-kelingking,gunting-telunjuk",
                            "gunting-telunjuk,batu-jempol"
                        ]
                    ].map((row, rowIdx) =>
                        row.map((groupComma, groupIdx) => {
                            const firstPercent = this.props.maximised ? 33.3 : 31;
                            const leftSpace = this.props.maximised ? 181 : 58;
                            const width = this.props.maximised ? "32px" : "25px";

                            return <div key={"m19_n2_1_" + rowIdx + "_" + groupIdx}
                                className={"sl-bet hidden sl-green-old"}
                                style={{
                                    position: "absolute",
                                    left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
                                    top: "calc(25% + " + (rowIdx * 50) + "px)",
                                    background: "transparent",
                                    width: width,
                                    height: "40px"
                                }}>
                                <Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
                                <div className="sl-hover-hidden"
                                    {...betGroupProp(this, groupComma, "n2")}
                                    onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
                            </div>;
                        })
                    )
                }

                {
                    [
                        [
                            "gunting-jempol,batu-telunjuk",
                            "batu-kelingking,kertas-jempol",
                            "kertas-telunjuk,gunting-kelingking"
                        ],
                        [
                            "batu-telunjuk,kertas-kelingking",
                            "kertas-jempol,gunting-telunjuk",
                            "gunting-kelingking,batu-jempol"
                        ]
                    ].map((row, rowIdx) =>
                        row.map((groupComma, groupIdx) => {
                            const firstPercent = this.props.maximised ? 21.3 : 22;
                            const leftSpace = this.props.maximised ? 181 : 58;
                            const width = this.props.maximised ? "140px" : "35px";

                            return <div key={"m19_n2_2_" + rowIdx + "_" + groupIdx}
                                className={"sl-bet hidden sl-green-old"}
                                style={{
                                    position: "absolute",
                                    left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
                                    top: "calc(42% + " + (rowIdx * 50) + "px)",
                                    background: "transparent",
                                    width: width,
                                    height: "26px"
                                }}>
                                <Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
                                <div className="sl-hover-hidden"
                                    {...betGroupProp(this, groupComma, "n2")}
                                    onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
                            </div>;
                        })
                    )

                }


                {
                    [
                        [
                            "gunting-jempol,batu-telunjuk,batu-kelingking,kertas-jempol",
                            "batu-kelingking,kertas-jempol,kertas-telunjuk,gunting-kelingking"
                        ],
                        [
                            "batu-telunjuk,kertas-kelingking,kertas-jempol,gunting-telunjuk",
                            "kertas-jempol,gunting-telunjuk,gunting-kelingking,batu-jempol"
                        ]
                    ].map((row, rowIdx) =>
                        row.map((groupComma, groupIdx) => {
                            const firstPercent = this.props.maximised ? 33.3 : 31;
                            const leftSpace = this.props.maximised ? 181 : 58;
                            const width = this.props.maximised ? "32px" : "25px";

                            return <div key={"m19_n4_3_" + rowIdx + "_" + groupIdx}
                                className={"sl-bet hidden sl-green-old"}
                                style={{
                                    position: "absolute",
                                    left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
                                    top: "calc(42.6% + " + (rowIdx * 50) + "px)",
                                    background: "transparent",
                                    width: width,
                                    height: "25px"
                                }}>
                                <Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
                                <div className="sl-hover-hidden"
                                    {...betGroupProp(this, groupComma, "n4")}
                                    onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
                            </div>;
                        })
                    )
                }
            </div>
        )
    }
}
